export default __webpack_public_path__ + "static/SanFranciscoText-Regular-aaf81f99b04210cadcd231719f2236ce.woff";